/** Client-side configuration derived from build-time env vars. */

/** Design resolution in game pixels — small, then scaled up crisply. */
export const GAME_WIDTH = 320;
export const GAME_HEIGHT = 240;

/** Colyseus game server URL (ws:// in dev, wss:// in prod). */
export const GAME_SERVER_URL =
  import.meta.env.VITE_GAME_SERVER_URL ?? "ws://localhost:2567";

/** Base URL for the auth/REST API. */
export const API_BASE_URL =
  import.meta.env.VITE_API_BASE_URL ?? "http://localhost:2567";
